import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import DragAndDropFile from "../../../../components/DragAndDropFile";
import UploadButton from "../../../../components/UploadButton";
import {exhibitionMapService} from "../../../../services/exhibition-map.service";

class ExhibitionMapConfigForm extends Component {

    state = {
        form: {
            id: null,
            label: null,
            imageSrc: null,
        },
        file: null
    };

    componentDidMount() {
        if(this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    id: this.props.data.id,
                    label: this.props.data.label,
                    imageSrc: this.props.data.imageSrc
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.file !== prevState.file) {
            const formData = new FormData();
            formData.append("file", this.state.file);

            exhibitionMapService.uploadMap(formData)
                .then(
                    tempPath => {
                        this.setState({
                            ...this.state,
                            form: {
                                ...this.state.form,
                                imageSrc: tempPath
                            }
                        });
                    }
                );
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleDrop = (file) => {
        this.setState({file: file[0]});
    };

    onChangeFileInput = (file) => {
        this.setState({file: file});
    };

    onSubmitForm = (e) => {
        const { submitForm } = this.props;
        e.preventDefault();

        submitForm(this.state.form);
    };

    render() {
        const { t } = this.props;

        const files = this.state.file ? (
            <p><small>{this.state.file.name}</small></p>
        ) : (
            <p><small> </small></p>
        );

        const imagePreview = this.state.form.imageSrc ? (
            <img
                className="w-100"
                src={this.state.form.imageSrc}
                alt="preview"
            />
        ) : (<React.Fragment/>);

        return(
            <React.Fragment>
                <form encType="multipart/form-data" onSubmit={this.onSubmitForm} >
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className="form-control"
                            name="label"
                            value={this.state.form.label || ''}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>
                    <div className="form-group">
                        { imagePreview }
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('image-map')}</label>
                        <DragAndDropFile className="form-control-file" handleDrop={this.handleDrop}>
                            { files }
                            <UploadButton
                                accept="image/*"
                                className="btn btn-outline-primary"
                                handleFile={this.onChangeFileInput}
                            >
                                <i className="fas fa-upload" /> &nbsp; {t('select-file')}
                            </UploadButton>
                        </DragAndDropFile>
                    </div>
                    <div className="form-group float-right">
                        { this.state.form.id ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </React.Fragment>
        )
    }
}
export default withNamespaces()(ExhibitionMapConfigForm);
